import { AppThunk } from '../../../../reducers';
import { setEditCLient, clearEditCLient, setClientSessions, clearClientSessions } from '../../../../reducers/users/users/editable';
import { ClientAdminImpersonationListItem } from 'common/model/client/clientAdminImpersonationListResponse';

export const setClientWithSession = (user: ClientAdminImpersonationListItem): AppThunk => (dispatch): void => {
    dispatch(setClientSessions(user));
};

export const clearClientWithSession = (): AppThunk => (dispatch): void => {
    dispatch(clearClientSessions());
};
